import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "#151515",
  "stroke-width": "1.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F56A00",
  stroke: "#151515",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m16.714 7.286-2.358 7.071-4.714-4.714z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#151515",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "m7.286 16.714 7.07-2.357-4.713-4.714z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#151515",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M18.702 15a8 8 0 0 1-2.026 2.5"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }